import { Tabs, Tab } from "@vds/tabs";
import { Select, Spin } from "antd";

import AssetFloorMap from "./AssetFloorMap";
import { Body, Title } from "@vds/typography";
import { useSelector, useDispatch } from "react-redux";
import {
  floorViewRequest,
  updateFilters,
  updateUI,
} from "../../../store/actions/asset";

function AssetFloor() {
  const dispatch = useDispatch();
  const { locations, selectedLocation, floorViewSettings } = useSelector(
    (state) => ({
      locations: state.asset.data.uniqueLocations || [],
      selectedLocation: state.asset.ui.selectedLocation || null,
      floorViewSettings: state.asset.ui.floorView,
    })
  );

  const handleZoomIn = () => {
    dispatch(
      updateUI({
        floorView: {
          ...floorViewSettings,
          scale: floorViewSettings.scale + 0.1,
        },
      })
    );
  };

  const handleZoomOut = () => {
    dispatch(
      updateUI({
        floorView: {
          ...floorViewSettings,
          scale: floorViewSettings.scale - 0.1,
        },
      })
    );
  };

  const handleDrag = (isDragging) => {
    dispatch(
      updateUI({
        floorView: {
          ...floorViewSettings,
          isDragging: isDragging,
        },
      })
    );
  };

  // Render the component
  // The canvas will be used to display the floor image for Floor 2
  // Other floors can be implemented similarly with their own content

  return (
    <div className="ats-tab-card ats-asset-floor-container">
      <div className="asset-floor-location-select">
        <Body size="large" bold={true}>
          Location:
        </Body>
        <Select
          value={selectedLocation?.id || null}
          placeholder=""
          style={{ width: "250px" }}
          disabled={floorViewSettings?.isLoading}
          options={[
            ...(Array.isArray(locations) && locations?.length > 0
              ? locations?.map((location) => ({
                  value: location.id,
                  label: location.name,
                  locationObj: location,
                }))
              : []),
          ]}
          onChange={(_, option) => {
            dispatch(
              floorViewRequest({
                location: option.locationObj,
                floorIndex: 0,
              })
            );
            dispatch(
              updateFilters({
                filters: {
                  assetstatus: {
                    sort: "",
                    option: [
                      {
                        text: "No Alert",
                        value: false,
                      },
                      {
                        text: "Warning",
                        value: false,
                      },
                      {
                        text: "Critical",
                        value: false,
                      },
                      {
                        text: "Notification",
                        value: false,
                      },
                    ],
                  },
                  assetname: {
                    sort: "asc",
                    option: "",
                  },
                  assetid: {
                    sort: "asc",
                    option: "",
                  },
                  devicename: {
                    sort: "asc",
                    option: "",
                  },
                  location: {
                    sort: "asc",
                    option: "",
                  },
                  updatedat: {
                    sort: "asc",
                    option: {
                      lastupdatedfrom: "",
                      lastupdatedto: "",
                    },
                  },
                  locationzone: {
                    sort: "asc",
                    option: `${option.locationObj?.name || ""} - ${
                      option.locationObj?.floors?.[0]?.name || ""
                    }`,
                  },
                },
                sort: {
                  field: "locationzone",
                  order: "asc",
                },
              })
            );
          }}
        />
      </div>
      {Array.isArray(selectedLocation?.floors) &&
      selectedLocation?.floors?.length > 0 ? (
        <Tabs
          key={selectedLocation?.id}
          orientation="vertical"
          indicatorPosition="bottom"
          width={"160px"}
          selectedIndex={
            Array.isArray(selectedLocation?.floors) &&
            selectedLocation?.floors?.length > floorViewSettings?.selectedIndex
              ? floorViewSettings?.selectedIndex
              : 0
          }
        >
          {selectedLocation?.floors?.map((floor, index) => (
            <Tab
              key={`${floor?.id}-${index}-tab`}
              label={floor?.name || " "}
              onClick={() => {
                dispatch(
                  floorViewRequest({
                    location: selectedLocation,
                    floorIndex: index,
                  })
                );
                dispatch(
                  updateFilters({
                    filters: {
                      locationzone: {
                        sort: "asc",
                        option:
                          `${selectedLocation?.name} - ${floor?.name}` || "",
                      },
                    },
                    sort: {
                      field: "locationzone",
                      order: "asc",
                    },
                  })
                );
              }}
            >
              <AssetFloorMap
                key={floor?.id}
                setting={floorViewSettings}
                floor={floor}
                onDrag={handleDrag}
                onZoomIn={handleZoomIn}
                onZoomOut={handleZoomOut}
              />
            </Tab>
          ))}
        </Tabs>
      ) : (
        <Spin spinning={floorViewSettings?.isLoading} tip="Loading...">
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ width: "100%", height: "450px" }}
          >
            {(floorViewSettings?.isLoading && !floorViewSettings?.isLoading) && (
              <Title size="medium" bold={true}>
                No floor map available for this location.
              </Title>
            )}
          </div>
        </Spin>
      )}
    </div>
  );
}

export default AssetFloor;
